import type { LiveAudienceTier } from '../../types/auth';

/**
 * «Кто увидит Live-сессию» в веб-форме создания и правки (CORE-505).
 *
 * Вынесено из `LiveStreamModal` ради CORE-879: под jest компоненты не
 * импортируются, а решение, какие пункты показать, проверять надо тестом.
 *
 * Pure (no React / RN imports).
 */
export interface LiveAudienceOption {
  key: LiveAudienceTier;
  icon: string;
  title: string;
  desc: string;
}

const COMMON_TIERS: LiveAudienceOption[] = [
  { key: 'all', icon: 'globe-outline', title: 'Все пользователи', desc: 'Live-сессия будет доступна всем' },
  { key: 'subscribers', icon: 'person-outline', title: 'Только подписчики', desc: 'Появится в ленте и календарях подписчиков, но не в публичном пространстве' },
  { key: 'private', icon: 'link-outline', title: 'Только по приглашению', desc: 'Доступен только по приглашению' },
];

const PROGRAM_TIER: LiveAudienceOption = {
  key: 'program',
  icon: 'school-outline',
  title: 'Только купившим программу',
  desc: 'Live-сессия входит в платную программу: увидят её и войдут в неё только купившие',
};

/**
 * Пункты выбора для сессии с сохранённым уровнем `savedTier`.
 *
 * CORE-879 — у Live-сессии, заведённой в разделе платной программы, уровень
 * `program`, и в форме правки его не было: ни один пункт не стоял отмеченным.
 * Мастер, открывший форму ради переноса, отмечал «Все пользователи» — и
 * проданная сессия становилась открытой всем. Пункт показывается только у
 * такой сессии: завести новую с этим уровнем можно лишь из редактора
 * программы, где у неё есть раздел.
 */
export function liveAudienceOptions(savedTier: LiveAudienceTier | null | undefined): LiveAudienceOption[] {
  return savedTier === 'program' ? [...COMMON_TIERS, PROGRAM_TIER] : COMMON_TIERS;
}

/**
 * Нужно ли Live-сессии с уровнем `tier` хотя бы одно направление.
 *
 * Направление держит событие в фильтрах общего календаря (AMB-197). Сессия
 * программы туда не попадает вовсе — её видят только купившие, — а редактор
 * программы направление и не спрашивает. Требовать его в форме правки значило
 * не дать перенести ни одну такую сессию (CORE-879, возврат QA 23.10). Сервер
 * без направления правку принимает: сохранённые остаются как были.
 */
export function liveDirectionsRequired(tier: LiveAudienceTier): boolean {
  return tier !== 'program';
}
